export class Wave {

  backend = {
    peaks: {},
    explicitDuration: {}
  };

  drawer = {
    updateSize() {}
  };

  drawBuffer() {}

  seekTo(num) {}

  create(options): Wave {
    return this;
  }

  destroy() {}
}
